import PocketTypes from "../models/PocketTypes";

class OrbRoute {
    index: number;
    route: string;
    pocket: string;

    constructor(index: number, route: string, pocket: string) {
        this.index = index;
        this.route = route;
        this.pocket = pocket;
    }
}

const OrbRoutes = [
    new OrbRoute(0, '/', PocketTypes.GAME),
    new OrbRoute(2, 'resume', PocketTypes.RESUME),
    new OrbRoute(1, 'showcase', PocketTypes.SHOWCASE),
    new OrbRoute(3, 'contact', PocketTypes.CONTACT),
    new OrbRoute(4, 'faith', PocketTypes.FAITH),
]

const GetOrbRouteByIndex = (ind: number): OrbRoute | null => {
    let filt = OrbRoutes.filter((o: OrbRoute) => {
        if (o.index === ind) {
            return true;
        }

        return false;
    });

    if (filt.length !== 1) {
        console.log("Err: no matches OrbRoutes or duplicate matches");
        return null;
    }

    return filt[0];
}

export default GetOrbRouteByIndex;